import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  Star, TrendingUp, Gift, Flame, Users, Coins, Lock, Trophy,
} from "lucide-react";

const ICON_MAP = {
  star: Star,
  "trending-up": TrendingUp,
  gift: Gift,
  flame: Flame,
  users: Users,
  coins: Coins,
};

export function BadgesSection({ userId }) {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const url = userId ? `/badges/user/${userId}` : "/badges";
    api.get(url)
      .then((res) => setData(res.data))
      .catch(console.error);
  }, [api, userId]);

  if (!data) return null;

  const badges = data.badges || [];
  const shown = expanded ? badges : badges.filter((b) => b.unlocked);
  if (shown.length === 0 && !expanded) return null;

  return (
    <div className="bg-card border border-border rounded-3xl p-5 space-y-3 shadow-sm" data-testid="badges-section">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy className="w-4 h-4 text-[#FFD700]" />
          <h3 className="font-heading font-bold text-sm text-card-foreground">
            Badges ({data.unlocked_count}/{data.total_count})
          </h3>
        </div>
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-xs text-[#FF6B35] hover:text-[#FF8FA3] transition-colors"
          data-testid="badges-toggle"
        >
          {expanded ? "Acquis" : "Voir tout"}
        </button>
      </div>

      <div className="grid grid-cols-4 gap-2">
        {shown.map((badge) => {
          const Icon = ICON_MAP[badge.icon] || Star;
          return (
            <div
              key={badge.id}
              className={`flex flex-col items-center gap-1 p-2.5 rounded-2xl border transition-all ${
                badge.unlocked
                  ? "bg-white border-border"
                  : "bg-muted border-border opacity-40"
              }`}
              title={`${badge.name}: ${badge.description}${!badge.unlocked ? ` (${badge.progress}/${badge.threshold})` : ""}`}
              data-testid={`badge-${badge.id}`}
            >
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center"
                style={{
                  backgroundColor: badge.unlocked ? `${badge.color}20` : "#E8E0D8",
                }}
              >
                {badge.unlocked ? (
                  <Icon className="w-4 h-4" style={{ color: badge.color }} />
                ) : (
                  <Lock className="w-3.5 h-3.5 text-muted-foreground" />
                )}
              </div>
              <p className="text-[9px] font-medium text-card-foreground text-center leading-tight truncate w-full">
                {badge.name}
              </p>
              {!badge.unlocked && (
                <div className="w-full bg-border rounded-full h-1 overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{
                      width: `${Math.min(100, (badge.progress / badge.threshold) * 100)}%`,
                      backgroundColor: badge.color,
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
